<template>
    <div>
        <b-row v-if="tabindex == 0 || tabindex == 1">
            <b-col>
                <b-form inline>
                  Desde: <b-input type="date" v-model="f1"/>
                  Hasta: <b-input type="date" v-model="f2"/>
                </b-form>
            </b-col>
            <b-col>
                <b-button @click="listInvoice" variant="success">Buscar</b-button>
            </b-col>
        </b-row>
        <br>
        <template v-if="cargandoDatos">
           <div class="text-center">
            <h3><i class="fa fa-spin fa-spinner"></i> Cargando...</h3>
           </div>
        </template>
        <template v-else-if="tabindex == 0 || tabindex == 1">
        <b-table
        responsive
        small
        striped
        outlined
        :items="invoices"
        :fields="invoices_fields">
        <template slot="serie" slot-scope="row">
            {{row.item.serie}} - {{row.item.numero}}
        </template>
        <template slot="receptor" slot-scope="row">
            <template v-if="row.item.idReceptor.length == 11">
                {{row.item.idReceptor}} - {{row.item.receiver.razonSocial}}
            </template>
            <template v-else-if="row.item.receiver.tipo == 0">
                {{row.item.idReceptor}} - {{row.item.receiver.razonSocial}}
            </template>
            <template v-else-if="row.item.receiver.tipo == 1">
                {{row.item.idReceptor}} - {{row.item.receiver.razonSocial}}
            </template>
        </template>
        <template slot="emisor" slot-scope="row">
                <template v-if="row.item && row.item.adicional && row.item.adicional !=''">
                    {{row.item.adicional.username}}
                </template>   
        </template>
        <template slot="total" slot-scope="row">
           <template>
            <div v-if="row.item.tipoMoneda == 'PEN'">
                S/ {{row.item.importeTotal}}
            </div>
            <div v-else-if="row.item.tipoMoneda == 'USD'">
                $ {{row.item.importeTotal}}
            </div>
            <div v-else-if="row.item.tipoMoneda == 'CAD'">
                C$ {{row.item.importeTotal}}
            </div>
            <div v-else-if="row.item.tipoMoneda == 'EUR'">
                € {{row.item.importeTotal}}
            </div>
           </template>  
        </template>
        <template slot="acciones" slot-scope="row">
            <b-button
             variant="primary"
             size="sm"
             @click="mostrarDetalles(row,row.index)">
            Ver Ticket
            </b-button>
        </template>
        </b-table>
        <b-row>
            <b-col>
                 <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
            </b-col>
            <b-col>
                <div class="float-right">
                    <b-pagination
                        size="sm"
                        :total-rows="total"
                        v-model="currentPage"
                        @input="listInvoice"
                        :per-page="limite"
                    ></b-pagination>
                </div>
            </b-col>
        </b-row>
        </template>
        <template v-else-if="tabindex == 2">
            <div>
                <b-table
                    responsive
                    small
                    striped
                    outlined
                    :items="proformas"
                    :fields="proformas_fields">
                    <template slot="emision" slot-scope="row">
                        {{ row.item.created_at | moment('Y-M-D hh:mm:ss A') }}
                    </template>
                    <template slot="serie" slot-scope="row">
                        <template v-if="row.item.proforma">
                            {{row.item.serie}}-{{row.item.numero}}
                        </template>
                    </template>
                    <template slot="receptor" slot-scope="row">
                        <template v-if="row.item.proforma.receptor">
                            {{row.item.proforma.receptor.nro}} - {{row.item.proforma.receptor.razonSocial}}
                        </template>
                    </template>
                    <template slot="usuario" slot-scope="row">
                        <template v-if="row.item.proforma.adicional">
                            {{row.item.proforma.adicional.username}}
                        </template>
                    </template>
                    <template slot="montoTotal" slot-scope="row">
                        <template v-if="row.item.proforma.moneda && row.item.proforma && row.item.proforma.totales">
                            {{row.item.proforma.moneda.simbolo}} {{parseFloat(row.item.proforma.totales.importeTotal).toFixed(2)}}
                        </template>
                    </template>
                    <template slot="acciones" slot-scope="row">
                        <b-button
                        variant="primary"
                        size="sm"
                        @click="mostrarDetallesProforma(row,row.index)">
                        Ver Ticket
                        </b-button>
                    </template>
                </b-table>
                <b-row>
                <b-col>
                    <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
                </b-col>
                <b-col>
                <div class="float-right">
                    <b-pagination
                        size="sm"
                        :total-rows="total"
                        v-model="currentPage"
                        @input="listProformas"
                        :per-page="limite"
                    ></b-pagination>
                </div>
                </b-col>
                </b-row>
            </div>
        </template>
        <b-modal size="xs" v-model="modalimpresion">
            <template slot="modal-header">
                <div class="text-center">
                Telemovil.global
                </div>
            </template>
            <template>
            <post-ticket-pdf v-if="tipopdv != 1" :impresion="dataImpresion" :printweb="printweb"></post-ticket-pdf>
            <post-ticket-pdf v-if="tipopdv == 1" :impresion="dataImpresion" :printweb="printweb"></post-ticket-pdf>
            </template>
            <template slot="modal-footer">
                <b-row>
                    <b-col cols="4" class="pr-0">
                        <template >
                            <b-form-input style="border-color:black;color:black" type="number" placeholder="Num. Celular" v-model="numberwsp"  @keyup.enter="send_message()"></b-form-input>
                        </template>
                    </b-col>
                    <b-col cols="2" class="pl-0">
                         <template>
                            <b-button title="Enviar a Whatsapp" style="border-color:black" variant="success"  @click="send_message()">
                                <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 448 512"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/></svg>
                            </b-button>
                        </template>
                    </b-col>
                    <b-col cols="3" class="pr-0">
                        <b-button size="sm"  class="btn btn-info" @click="print()"><i class="fas fa-print"></i> Imprimir</b-button>
                    </b-col>
                    <b-col cols="3" class="pl-0">
                        <b-button size="sm" class="btn btn-success" @click="nuevaImpresion()"><i class="fas fa-plus"></i> Nuevo</b-button>
                    </b-col>
                </b-row>
            </template>
        </b-modal>
    </div>
</template>
<script>
import PostTicketPdf from '@/components/comunes/PostTicketPdf'
import PlantillaGrifo from '@/components/comunes/PlantillaGrifo'
import axios from "axios";
export default {
    name:"TicketsMarket",
    components:{
        PlantillaGrifo,
        PostTicketPdf,
    },
     props: ["tabindex","tipopdv"],
    data() {
        return {
            invoices: [],
            invoices_fields: [
                { key: "serie", label: "Serie - Número", sorteable: true },
                { key: "receptor", label: "Receptor", sorteable: true },
                { key: "fechaEmision", label: "Fecha Emision", sorteable: true },
                { key:  'emisor', label: 'Usuario', sortable: true},
                { key:  'total', label: 'Total', sortable: true},
                { key: "acciones", label: "Acciones" }
            ],
            proformas: [],
            proformas_fields: [
                {key: 'serie', label: 'Serie - Número', sorteable: true},
                {key: 'receptor', label: 'Receptor', sorteable: true},
                {key: 'emision', label: 'Emisión', sorteable: true},
                {key: 'usuario', label: 'Usuario', sorteable: true},
                {key: 'montoTotal', label: 'Monto Total', sorteable: true},
                {key: 'acciones', label: 'Acciones'}
            ],
            total: 0.0,
            desde: 0.0,
            hasta: 0.0,
            orden: "desc",
            limite: 10,
            currentPage:1,
            f1:'',
            f2:'',
            dataImpresion: {},
            modalimpresion:false,
            printweb: false,
            cargandoDatos:true,
            numberwsp:'',
        }
    },
    mounted() {
        if(this.tabindex == 0 || this.tabindex == 1){
            this.listInvoice();
        }else if(this.tabindex == 2){
            this.listProformas();
        }
    },
    methods: {
        listInvoice: function() {
        let dia1;
        let dia2;
        let ruta;
        if(this.f1 === "" && this.f2 ===""){
            dia1 =  ""
            dia2 = ""
        }else{
            dia1 = this.$moment(this.f1).format('YYYY-MM-DD HH:mm:ss')
            dia2 = this.$moment(this.f2).format('YYYY-MM-DD 23:59:59')          
        }
        this.cargando = true;
        if(this.tabindex == 0){
            ruta = "facturas"
        }else if(this.tabindex == 1){
            ruta = "boletas"
        }
        this.cargandoDatos = true;
    
        // Construir dinámicamente el objeto de datos
            let requestData = {
                token: this.$store.getters.userToken,
                page: this.currentPage,
                limit: this.limite,
                order: this.orden
            };

            // Agregar f1 y f2 solo si tienen valores
            if (dia1) {
                requestData.f1 = dia1;
            }
            if (dia2) {
                requestData.f2 = dia2;
            }
        axios
            .post(process.env.VUE_APP_API_URL + ruta, requestData)
            .then(
            response => (
                (this.invoices = response.data.data),
                this.cargandoDatos = false,
                (this.total = response.data.total),
                (this.desde = response.data.from),
                (this.hasta = response.data.to),
                (this.cargando = false)
            ))
            .catch(error => {});
        },
        mostrarDetalles(row,index){
        console.log(row,index)
            if (this.invoices[index].lista.length == 0) {
                setTimeout(() => this.detallesDocumento(row, index), 10)
            }else{
                setTimeout(() => this.detallesDocumento(row, index), 10)
            }
        },
        detallesDocumento: function(row, index) {
            let ruta;
            let parametros;
            if(this.tabindex == 0){
            ruta = "facturas/items"
        }else if(this.tabindex == 1){
            ruta = "boletas/items"
        }
        if(this.tabindex == 0){
             parametros = {
            token:this.$store.getters.userToken,
            idfac:row.item.idFactura
            }
        }else if(this.tabindex == 1){
            parametros = {
            token:this.$store.getters.userToken,
            idbol:row.item.idBoleta
            }
        }
        axios
            .post(process.env.VUE_APP_API_URL + ruta,parametros)
            .then(response =>
            this.parseDetallesDocumento(response.data.response, row, index)
            )
            .catch(error => (this.invoices[index].mostrardetalles = false));
        },
        listProformas: function () {
            this.cargando = true;
            this.cargandoDatos = true;
            axios
            .post(process.env.VUE_APP_API_URL + 'proformas/listar', {
                token: this.$store.getters.userToken,
                page: this.currentPage,
                limit: this.limite,
                order: this.orden
            })
            .then(response => (
                this.proformas = response.data.data,
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to,
                this.cargando = false,
                this.cargandoDatos = false
            ))
            .catch(error => {
                this.$snotify.error(error.response.data.msg,'Error')
            })
        },
        mostrarDetallesProforma(valor){
            this.dataImpresion = valor.item
            this.modalimpresion = true
        },
        parseDetallesDocumento: function(value, row, index) {
            this.invoices[index].lista = [];
            for (let i = 0; i < value.length; i++) {
                value[i].moneda = row.item.tipoMoneda;
                this.invoices[index].lista.push(value[i]);
            }
            this.dataImpresion = this.invoices[index];
            this.modalimpresion = true
        },
        print: function () {
            this.printweb = true
        },
        nuevaImpresion(){
            this.modalimpresion = false;
        },
        send_message(){
            if(this.numberwsp && this.numberwsp.trim() !== ''){
                if(this.numberwsp.length == 9){
                    const url = 'https://micomprobante.facturaonline.pe/s/pkey-'
                    const {
                        idEmisor,
                        serie,
                        numero,
                        idReceptor,
                        importeTotal
                    } = this.dataImpresion
                    let codigoComprobante
                    if(this.tabindex == 0){
                        codigoComprobante = '01'    //facturas
                    }else if(this.tabindex == 1){
                        codigoComprobante = '03'    //boletas
                    }
                    const mensaje = 'Comprobante' + ' ' +this.dataImpresion.serie +'-'+ this.dataImpresion.numero + ' ' + 'Emitido a través de TELEMOVILPERU.COM'
                    const cadena = `${idEmisor}|${codigoComprobante}|${serie}|${numero}|${idReceptor}|${importeTotal}`
                    const text = `${url}.${btoa(cadena)}+${mensaje}`
                    window.open(`https://wa.me/+51${this.numberwsp}?text=${text}`, '_blank')
                }else{
                    this.$snotify.warning("DEBE INGRESAR 9 DIGITOS")
                }
            }else{
                this.$snotify.warning("DEBE INGRESAR NUMERO CELULAR")
            }
        },
    },
}
</script>